// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3w","pending":"e_4w","slider":"e_5w","imageContainer":"e_6w","image":"e_7w","button":"e_8w","prevButton":"e_9w","nextButton":"e_-w","disabled":"e_ax"};